import React, { useEffect, useState } from "react";
import './FileManagerSidebar.css'
import { FaFolder } from "react-icons/fa";
import { FaFolderOpen } from "react-icons/fa";
import { MdArrowDropDown } from "react-icons/md";
import { MdArrowRight } from "react-icons/md";
import { FaFile } from "react-icons/fa";
import { TbFileUpload } from "react-icons/tb";
import { MdRefresh } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
const FileManagerSidebar = () => {

    const [fileManager, setFileManager] = useState({});
    const [isLoadingFiles, setIsLoadingFiles] = useState(false);

    const handleFileUpload = async (event) => {

        const file = event.target.files[0];

        const data = new FormData();
        data.append('host', '74.80.190.17');
        data.append('username', 'sabhay');
        data.append('input_secret', 'abcdefgh567635@#%!&');
        data.append('file', file);
        try {
            const data11 = await toast.promise(
                fetch('https://workable-ai-ml-2.onrender.com/upload-file', {
                    method: 'POST',
                    body: data
                }).then(res => {
                    if (res.ok) {
                        console.log({ ...fileManager, [file["name"]]: {} })
                        setFileManager({ ...fileManager, [file["name"]]: {} });
                        return res.text();
                    } else {
                        throw new Error('Error in upload');
                    }
                })
                    .then(text => console.log(text))
                    .catch(err => console.log(err)),
                {
                    pending: 'Uploading File: ' + file.name,
                    success: 'Uploaded File: ' + file.name,
                    error: 'Error Uploading File' + file.name,
                }
            );
        } catch (error) {
            console.log(error);
        } finally {
            event.target.value = "";

        }
    };
    const ListFilesAPI_ = async () => {
        setIsLoadingFiles(true);
        try {
            const url = "https://workable-ai-ml-2.onrender.com/list-files";
            const payload = {
                "host": "74.80.190.17",
                "username": "sabhay",
                "secret": "abcdefgh567635@#%!&",
            }
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Access-Control-Allow-Origin": "*",
                },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                const data = await response.json();
                if (data && data.output) {
                    setFileManager(data.output)
                }
            } else { console.error("reponse not ok") }
        } catch (error) {
            console.log(error)
        }
        finally {
            setIsLoadingFiles(false);
        }

    }
    const RefreshListFiles = () => {
        ListFilesAPI_();
    }
    useEffect(() => {
        ListFilesAPI_();
    }, []);
    const [expand, setExpand] = useState(true);
    return (
        <div style={{ color: "white" }}>
            <div className="upload_file_navbar">
                <span style={{ fontSize: "20px", fontWeight: "500" }}> Files</span>
                <button disabled={isLoadingFiles} title={"Refresh"} style={{ background: "none", border: "none", cursor: "pointer", color: isLoadingFiles ? "#ffffff21" : "white" }} onClick={RefreshListFiles}>
                    <MdRefresh className="upload-icons-sizes" />
                </button>
                <label style={{ cursor: "pointer" }} htmlFor="file-upload" className="custom-file-upload">
                    <TbFileUpload className="upload-icons-sizes" />
                </label>
                <input id="file-upload" type="file" onChange={handleFileUpload} style={{ display: 'none' }} />
            </div>
            <div onClick={() => setExpand(!expand)} className="expand-icon">
                {!expand && <div><MdArrowRight className="icons-sizes" /><FaFolder className="icons-sizes" /></div>}
                {expand && <div><MdArrowDropDown className="icons-sizes" /><FaFolderOpen className="icons-sizes" /></div>}
                <span className="folder-style">{"/root"}</span>
            </div>
            <div style={{ display: expand ? "block" : "none", paddingLeft: 10 }} >
                {
                    Object.entries(fileManager).map(([key, value]) => (
                        value !== "" && <Folder key={key} name={key} file={value} />
                    ))
                }
            </div>
            <ToastContainer
                position="top-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            // transition:Bounce
            />
        </div>
    );
}

function Folder({ name, file }) {
    const [expand, setExpand] = useState(false);
    if (typeof file !== "object" || JSON.stringify(file) === '{}') return (
        <div className="filename-div" title={name} style={{ paddingLeft: 20 }}>
            <span className="filename-div-1">
                <FaFile />
                <span className="folder-style">{name}</span>
            </span>
            <div className="filename-div-2"><DownloadFile file={name} /></div>
        </div>
    )
    return (
        <div>
            <div onClick={() => setExpand(!expand)} className="expand-icon">
                {!expand && <div><MdArrowRight className="icons-sizes" /><FaFolder className="icons-sizes" /></div>}
                {expand && <div><MdArrowDropDown className="icons-sizes" /><FaFolderOpen className="icons-sizes" /></div>}
                <span className="folder-style">{name}</span>
            </div>
            <div style={{ display: expand ? "block" : "none", paddingLeft: 10 }} >
                {
                    Object.entries(file).map(([key, value]) => (
                        <Folder key={key} name={key} file={value} />
                    ))
                }
            </div>
        </div>
    );
}

const DownloadFile = (props) => {
    const filename = props.file;
    const handleDownload = async (file_path) => {
        const formData = new FormData();
        formData.append('host', '74.80.190.17');
        formData.append('username', 'sabhay');
        formData.append('input_secret', 'abcdefgh567635@#%!&');
        formData.append('file_path', file_path);
        try {
            toast.promise(
                fetch('https://workable-ai-ml-2.onrender.com/download-file', {
                    method: "POST",
                    body: formData,
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Failed to download file');
                        }
                        return response.blob();
                    })
                    .then(blob => {
                        // Create a temporary URL for the blob
                        const url = window.URL.createObjectURL(blob);

                        // Create a link element
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file_path); // Set the filename here

                        // Append the link to the document body
                        document.body.appendChild(link);

                        // Trigger the download
                        link.click();

                        // Cleanup
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(error => {
                        // Handle errors
                        console.error('Error downloading file:', error);
                    }),
                {
                    pending: 'Downloading File: ' + file_path,
                    success: 'Downloaded File: ' + file_path,
                    error: 'Error Downloading File' + file_path,
                })
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <button title={"Download " + filename} style={{ background: "none", border: "none", cursor: "pointer" }} onClick={() => handleDownload(filename)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="download" fill="white">
                <path d="M5 9c-.6 0-1-.4-1-1 0-3.9 3.1-7 7-7 3 0 5.7 2 6.7 4.9.1.5-.1 1.1-.7 1.2-.5.2-1.1-.1-1.3-.6C15.1 4.4 13.2 3 11 3 8.2 3 6 5.2 6 8c0 .6-.4 1-1 1z"></path>
                <path d="M18 17c-.6 0-1-.4-1-1s.4-1 1-1c2.2 0 4-1.8 4-4s-1.8-4-4-4c-.3 0-.7 0-1 .1-.5.1-1.1-.2-1.2-.7-.1-.5.2-1.1.7-1.2.5-.1 1-.2 1.5-.2 3.3 0 6 2.7 6 6s-2.7 6-6 6zM8 17H5c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1z"></path>
                <path d="M18 17h-2c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1zM5 17c-2.8 0-5-2.2-5-5s2.2-5 5-5c.6 0 1 .4 1 1s-.4 1-1 1c-1.7 0-3 1.3-3 3s1.3 3 3 3c.6 0 1 .4 1 1s-.4 1-1 1zm7 6c-.6 0-1-.4-1-1v-9c0-.6.4-1 1-1s1 .4 1 1v9c0 .6-.4 1-1 1z"></path>
                <path d="M12 23c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l3-3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-3 3c-.2.2-.4.3-.7.3z"></path>
                <path d="M12 23c-.3 0-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l3 3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z"></path>
            </svg>
        </button>
    )
}

export default React.memo(FileManagerSidebar);